// 化工泵工位页面（柯瓦斯）
export default [
  // 二供-化工泵--工位（柯瓦斯）
  {
    path: "/:lang/HG/Item/Index",
    name: "hgItemIndex",
    meta: {
      title: "",
      cache: false,
      noFrame: true,
      noPermissionValidate: true,
      keepAlive: true,
      isLoaded: false,
    },
    component: () => import("/@/views/HG/Item/Index.vue"),
  },

  // 二供-化工泵--项目列表（柯瓦斯）
  {
    path: "/:lang/HG/Project/List/Index",
    name: "hgProjectIndex",
    meta: {
      title: "",
      cache: false,
      noFrame: true,
      noPermissionValidate: true,
      keepAlive: true,
      isLoaded: false,
    },
    component: () => import("/@/views/HG/Project/List/Index.vue"),
  },
  // 二供-化工泵--添加项目（柯瓦斯）
  {
    path: "/:lang/HG/Project/Add/Index",
    name: "HGProjectAdd",
    meta: {
      title: "项目添加",
      cache: false,
      noFrame: true,
      noPermissionValidate: true,
      keepAlive: true,
      isLoaded: false,
    },
    component: () => import("/@/views/HG/Project/Add/Index.vue"),
  },
  // 二供-化工泵--编辑项目（柯瓦斯）
  {
    path: "/:lang/HG/Project/Edit/Index",
    name: "HGProjectEdit",
    meta: {
      title: "项目编辑",
      cache: false,
      noFrame: true,
      noPermissionValidate: true,
      keepAlive: true,
      isLoaded: false,
    },
    component: () => import("/@/views/HG/Project/Edit/Index.vue"),
  },
];
